// apps/web/src/components/ui/Button.tsx
// The one action-button primitive. Pill-shaped, brand-aware, with built-in
// press feedback + disabled styling. Use for standard action buttons (not
// segmented toggles or bare icon buttons).
import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost";

const VARIANT: Record<Variant, string> = {
  primary: "bg-brand text-on-brand",
  secondary: "bg-surface-strong text-fg",
  danger: "bg-danger/20 text-danger",
  ghost: "text-fg-secondary",
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
}

export function Button({ variant = "primary", fullWidth = false, className = "", type, ...props }: Props) {
  return (
    <button
      type={type ?? "button"}
      className={`press rounded-full font-medium text-sm px-5 py-3 transition disabled:opacity-50 ${
        fullWidth ? "w-full" : ""
      } ${VARIANT[variant]} ${className}`}
      {...props}
    />
  );
}
